const MicrosoftAzureFunctions = () => {
  return <h1>MicrosoftAzureFunctions  </h1>;
};

export default MicrosoftAzureFunctions;